// Copyright 2026, University of Maryland, All Rights Reserved
/**
 * Renderer-component wrapper for `diff-viewer`.
 *
 * Reads the `changes` slot binding off the renderer config and hands it to
 * DatasetDiffViewer. If the slot is unbound, the AI Analysis tab shows a
 * "not configured" message; the Text Diff tab still works.
 */
import { type FC } from 'react'

import type { RendererComponentProps } from '@/app-shell/renderer-components'
import { DatasetDiffViewer } from '../components/diff-viewer'

export const DiffViewerRenderer: FC<RendererComponentProps> = ({
  renderer,
  documentId,
  oldVersion,
  newVersion,
  orgId,
  workspaceId,
  apiClient,
  agentId,
}) => {
  if (oldVersion === undefined || newVersion === undefined) {
    return (
      <p className="text-sm text-muted-foreground">
        Diff viewer requires two document versions.
      </p>
    )
  }

  const datasetKey = renderer.slots.find(s => s.key === 'changes' && s.type === 'dataset')?.datasetKey

  return (
    <DatasetDiffViewer
      documentId={documentId}
      oldVersion={oldVersion}
      newVersion={newVersion}
      orgId={orgId}
      workspaceId={workspaceId}
      apiClient={apiClient}
      agentId={agentId}
      datasetKey={datasetKey}
      className="h-full"
    />
  )
}
